import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { eventData } from '../mockData';
import { useEventDialog } from '../context/EventDialogContext';

const Footer = () => {
  const { openInspiration, openRSVP } = useEventDialog();

  return (
    <footer className="bg-black border-t border-orange-600/30 py-12 px-4">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl mad-max-title mb-4">
              FURY ROSE
            </h3>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-orange-400 font-bold mb-4 text-lg">Navigation</h4>
            <nav className="flex flex-col gap-2 items-start">
              <Link to="/" data-testid="footer-link-home" className="text-gray-400 hover:text-orange-400 transition-colors">Accueil</Link>
              <button
                onClick={openInspiration}
                data-testid="footer-link-inspiration"
                className="text-gray-400 hover:text-orange-400 transition-colors text-left"
              >
                Inspiration
              </button>
              <button
                onClick={openRSVP}
                data-testid="footer-link-rsvp"
                className="text-gray-400 hover:text-orange-400 transition-colors text-left"
              >
                RSVP
              </button>
              <Link to="/contact" data-testid="footer-link-contact" className="text-gray-400 hover:text-orange-400 transition-colors">Contact et Lieu</Link>
              <Link to="/photos" data-testid="footer-link-photos" className="text-gray-400 hover:text-orange-400 transition-colors">Photos</Link>
              <Link to="/remerciement" data-testid="footer-link-remerciement" className="text-gray-400 hover:text-orange-400 transition-colors">Remerciement</Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-orange-400 font-bold mb-4 text-lg">Contact</h4>
            <div className="space-y-3">
              <a href={`mailto:${eventData.contact.email}`} className="flex items-center gap-2 text-gray-400 hover:text-orange-400 transition-colors">
                <Mail className="w-4 h-4" />
                {eventData.contact.email}
              </a>
              <a href={`tel:${eventData.contact.phone}`} className="flex items-center gap-2 text-gray-400 hover:text-orange-400 transition-colors">
                <Phone className="w-4 h-4" />
                {eventData.contact.phone}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-orange-600/20 text-center">
          <p className="text-gray-500 text-sm">
            © 2026 Fury Rose. Tous droits réservés. | Organisé par {eventData.contact.organizer}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
